window.addEventListener('DOMContentLoaded', () => {

  let observer = lozad();
  observer.observe();

  $(function() {
    $('.fn-accordion-list .question').on('click', (event) => {
      const target = $(event.currentTarget);
      const parent = target.parent();
      const answer = parent.find('.answer');
      if (parent.hasClass('is-active')) {
        parent.removeClass('is-active');
        answer.slideUp();
      } else {
        parent.addClass('is-active');
        answer.slideDown();
      }
    });

    const menuButton = $('.fn-menu-button');
    const headerNav = $('.fn-nav');
    menuButton.on('click', (event) => {
      const target = $(event.currentTarget);

      if (target.hasClass('is-open')) {
        target.removeClass('is-open');
        headerNav.slideUp();
      } else {
        target.addClass('is-open');
        headerNav.slideDown();
      }
    });


    headerNav.on('click', (event) => {
      const target = $(event.currentTarget);
      if (menuButton.hasClass('is-open')) {
        menuButton.removeClass('is-open');
        target.slideUp();
      }
    });

    $('a[href^="#"]').on('click', (e) => {
      let position = 0;
      const speed = 500;
      const href = $(e.currentTarget).attr('href');
      const target = $(href == '#' || href == '' ? 'html' : href);
      if (href !== '#top') {
        position = target.offset().top;
      }
      $('html, body').stop().animate({scrollTop: position - 60}, speed, 'swing', () => {
        window.location = href;
        position = target.offset().top;
        window.scrollTo(0, position - 60);
        return false;
      });
    });

    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.slider-nav',
      lazyLoad: 'ondemand',
    });
    $('.slider-nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: true,
      focusOnSelect: true,
      lazyLoad: 'ondemand',
    });

  });

});
